import { _get, strContains } from '@/utils';

//old functionality was that arrays were 1 layer and OR
//new functionality is that arrays are 2 layers and OR with nested AND condition arrays
export function handleOrConditionArray(conditionArray = [], testFn = () => {}) {
	return conditionArray.some(orCondition => {
		if (orCondition instanceof Array) {
			return orCondition.every(andCondition => testFn(andCondition));
		}

		return testFn(orCondition);
	});
}

function isNumericString(str) {
	if (typeof str !== 'string' || str.trim() === '') return false;
	const num = Number(str);
	return !isNaN(num) && num.toString() === str.trim();
}

export function testCondition({ value1, value2, value3, operator = 'matches exactly', regex = false }) {
	switch (operator) {
		case 'exists':
			return value1 !== undefined;

		case 'does not exist':
			return value1 === undefined;

		case 'contains':
			if (Array.isArray(value1)) {
				return value1.indexOf(value2) > -1;
			}
			if (Array.isArray(value2)) {
				return value2.some(item => strContains(value1, item, regex));
			}
			return strContains(value1, value2, regex);

		case 'does not contain':
			if (Array.isArray(value1)) {
				return value1.indexOf(value2) === -1;
			}
			if (Array.isArray(value2)) {
				return value2.some(item => !strContains(value1, item, regex));
			}
			return !strContains(value1, value2, regex);

		case 'is boolean':
			return typeof value1 === 'boolean' && String(value1) === value2;

		//date time comparisons
		// value1 = set date, value3 = current date
		//@todo: probably pass more descriptive arguments
		case 'earlier':
			return value1 > value3;
		case 'exactly':
			return value1 === value3;
		case 'between':
			return value1 <= value3 && value2 >= value3;
		case 'later':
			return value1 < value3;

		case 'matches exactly':
		default:
			if (Array.isArray(value2)) {
				return value2.some(item => {
					if (isNumericString(item)) {
						return value1 === Number(item) || value1 === item;
					}

					return value1 === item;
				});
			}

			if (isNumericString(value2)) {
				return value1 === Number(value2) || value1 === value2;
			}

			return value1 === value2;
	}
}

function dateAsTime(date) {
	const dateInstance = typeof date === 'string' ? new Date(date) : new Date();
	return dateInstance.getTime();
}

function dateStringToTime(dateString, endOfDay) {
	const dateArr = dateString
		.split('/')
		.reverse()
		.map((str, index) => {
			if (index === 0) {
				return str;
			}
			return prependZeroStr(str);
		});

	const time = endOfDay ? 'T23:59' : 'T00:01';
	const dateTimeString = `${dateArr.join('-')}${time}`;
	return dateAsTime(dateTimeString);
}

function todaysDateString() {
	const date = new Date();
	return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
}

export function prepareDateComparison({ date = '', date2 = '', operator = 'exactly' }) {
	return {
		value1: dateStringToTime(date),
		value2: dateStringToTime(date2, true),
		value3: dateStringToTime(todaysDateString()),
		operator,
	};
}

export function prepareTimeComparison({ time = '', time2 = '', operator = 'exactly' }) {
	const now = new Date();
	const hours = prependZeroStr(now.getHours());
	const minutes = prependZeroStr(now.getMinutes());
	const currentTime = `${hours}:${minutes}`;

	return {
		value1: time,
		value2: time2,
		value3: currentTime,
		operator,
	};
}

export function getCssSelectorTextContent(selector = '') {
	try {
		const node = document.querySelector(selector);
		if (!node) {
			return undefined;
		}

		const textContent = node.textContent || node.innerText;
		return textContent.replace(/^\s+|\s+$/g, ''); //trim whitespace
	} catch (e) {
		return undefined;
	}
}

export function getJsFromString(str) {
	try {
		return _get(window, str, undefined);
	} catch (e) {
		return undefined;
	}
}

export function getDeviceType() {
	//https://github.com/kaimallea/isMobile
	const apple_phone = /iPhone/i,
		apple_ipod = /iPod/i,
		apple_tablet = /iPad/i,
		android_phone = /(?=.*\bAndroid\b)(?=.*\bMobile\b)/i, // Match 'Android' AND 'Mobile'
		android_tablet = /Android/i,
		amazon_phone = /(?=.*\bAndroid\b)(?=.*\bSD4930UR\b)/i,
		amazon_tablet =
			/(?=.*\bAndroid\b)(?=.*\b(?:KFOT|KFTT|KFJWI|KFJWA|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|KFARWI|KFASWI|KFSAWI|KFSAWA)\b)/i,
		windows_phone = /Windows Phone/i,
		windows_tablet = /(?=.*\bWindows\b)(?=.*\bARM\b)/i, // Match 'Windows' AND 'ARM'
		other_blackberry = /BlackBerry/i,
		other_blackberry_10 = /BB10/i,
		other_opera = /Opera Mini/i,
		other_chrome = /(CriOS|Chrome)(?=.*\bMobile\b)/i,
		other_firefox = /(?=.*\bFirefox\b)(?=.*\bMobile\b)/i, // Match 'Firefox' AND 'Mobile'
		seven_inch = new RegExp(
			'(?:' + // Non-capturing group
				'Nexus 7' + // Nexus 7
				'|' + // OR
				'BNTV250' + // B&N Nook Tablet 7 inch
				'|' + // OR
				'Kindle Fire' + // Kindle Fire
				'|' + // OR
				'Silk' + // Kindle Fire, Silk Accelerated
				'|' + // OR
				'GT-P1000' + // Galaxy Tab 7 inch
				')', // End non-capturing group

			'i'
		); // Case-insensitive matching

	const match = function (regex, userAgent) {
		return regex.test(userAgent);
	};

	const isAppleTabletIos13AndUp = () => {
		return /Macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints && navigator.maxTouchPoints > 1;
	};

	let ua = navigator.userAgent;

	// Facebook mobile app's integrated browser adds a bunch of strings that
	// match everything. Strip it out if it exists.
	let tmp = ua.split('[FBAN');
	if (typeof tmp[1] !== 'undefined') {
		ua = tmp[0];
	}

	// Twitter mobile app's integrated browser on iPad adds a "Twitter for
	// iPhone" string. Same probable happens on other tablet platforms.
	// This will confuse detection so strip it out if it exists.
	tmp = ua.split('Twitter');
	if (typeof tmp[1] !== 'undefined') {
		ua = tmp[0];
	}

	const deviceData = {
		apple: {
			phone: match(apple_phone, ua),
			ipod: match(apple_ipod, ua),
			tablet: (!match(apple_phone, ua) && match(apple_tablet, ua)) || isAppleTabletIos13AndUp(),
			device: match(apple_phone, ua) || match(apple_ipod, ua) || match(apple_tablet, ua),
		},
		amazon: {
			phone: match(amazon_phone, ua),
			tablet: !match(amazon_phone, ua) && match(amazon_tablet, ua),
			device: match(amazon_phone, ua) || match(amazon_tablet, ua),
		},
		android: {
			phone: match(amazon_phone, ua) || match(android_phone, ua),
			tablet:
				!match(amazon_phone, ua) &&
				!match(android_phone, ua) &&
				(match(amazon_tablet, ua) || match(android_tablet, ua)),
			device:
				match(amazon_phone, ua) || match(amazon_tablet, ua) || match(android_phone, ua) || match(android_tablet, ua),
		},
		windows: {
			phone: match(windows_phone, ua),
			tablet: match(windows_tablet, ua),
			device: match(windows_phone, ua) || match(windows_tablet, ua),
		},
		other: {
			blackberry: match(other_blackberry, ua),
			blackberry10: match(other_blackberry_10, ua),
			opera: match(other_opera, ua),
			firefox: match(other_firefox, ua),
			chrome: match(other_chrome, ua),
			device:
				match(other_blackberry, ua) ||
				match(other_blackberry_10, ua) ||
				match(other_opera, ua) ||
				match(other_firefox, ua) ||
				match(other_chrome, ua),
		},
	};

	return {
		seven_inch: match(seven_inch, ua),
		phone: deviceData.apple.phone || deviceData.android.phone || deviceData.windows.phone,
		// excludes 7 inch devices, classifying as phone or tablet is left to the user
		tablet: deviceData.apple.tablet || deviceData.android.tablet || deviceData.windows.tablet,
	};
}

function parseSelector(selector = '') {
	if (['#', '.', '['].indexOf(selector?.charAt(0)) > -1) {
		return selector;
	}

	return `#${selector}`;
}

function cleanSelector(selector = '') {
	try {
		return selector.trim().split(' ').shift();
	} catch (e) {
		return selector;
	}
}

export function divExists(selector) {
	try {
		const parsedSelector = parseSelector(selector);
		return Boolean(document.querySelector(parsedSelector));
	} catch (e) {
		return false;
	}
}

function parseAttributeSelector(str = '') {
	try {
		const [attr, value] = str.split('=');
		return {
			attr: attr?.replace(/\[/g, '').replace(/\]/g, '') ?? '',
			value: value?.replace(/\]/g, '') ?? '',
		};
	} catch (e) {
		return {};
	}
}

export function createDiv(selector) {
	const parsedAndCleaned = parseSelector(cleanSelector(selector));
	if (!divExists(parsedAndCleaned)) {
		const div = document.createElement('div');
		if (parsedAndCleaned?.charAt(0) === '#') {
			div.id = parsedAndCleaned.replace('#', '');
		}

		if (parsedAndCleaned?.charAt(0) === '.') {
			div.className = parsedAndCleaned.replace('.', '');
		}

		if (parsedAndCleaned?.charAt(0) === '[') {
			const { attr, value } = parseAttributeSelector(parsedAndCleaned);
			if (attr) {
				div.setAttribute(attr, value);
			}
		}

		document.body.appendChild(div);
	}
}

export function conditionValueIsEmpty(value) {
	if (typeof value === 'undefined' || value === null) {
		return true;
	}

	if (typeof value === 'string') {
		return value.trim() === '';
	}

	if (value && typeof value === 'object') {
		return Object.keys(value).length === 0;
	}

	if (typeof value === 'number') {
		return isNaN(value);
	}

	return false;
}

export function tryService(fn, limit = 10) {
	let counter = 0;
	const interval = setInterval(() => {
		try {
			fn();
			clearInterval(interval);
		} catch (e) {}

		counter++;
		if (counter >= limit) {
			clearInterval(interval);
		}
	}, 100);
}

export function handleDivPlacement(then = [], valid) {
	if (!checkDivs(then)) {
		then.forEach((thenCondition = {}) => {
			const selector = thenCondition.args[2];
			const exists = divExists(selector);
			if (!exists && !thenCondition.disableMakeDiv && valid) {
				createDiv(selector);
			}
		});
	}
	return checkDivs(then);
}

export function checkDivs(then) {
	return then.every((thenCondition = {}) => {
		const selector = thenCondition.args[2];
		return divExists(selector);
	});
}

export function randomPercentage() {
	return (Math.random() * 100).toFixed(1).toString();
}

export function getDiffInDays(pastTimestamp = '', currentTimestamp) {
	const pastTime = new Date(pastTimestamp).getTime();
	const currentTime = currentTimestamp ? new Date(currentTimestamp).getTime() : new Date().getTime();

	return Math.floor((currentTime - pastTime) / (1000 * 3600 * 24));
}

function prependZeroStr(str, len = 2) {
	return `0${str}`.slice(-len);
}

export function parseUrlString(str = '') {
	if (typeof str !== 'string') {
		return '';
	}

	return str.replace(/^(?:https?:\/\/)?(?:www\.)?/, '').replace(/\/+$/, '');
}
